import { render } from "./LineDetail.vue?vue&type=template&id=4916d420&scoped=true"
import script from "./LineDetail.vue?vue&type=script&lang=js"
export * from "./LineDetail.vue?vue&type=script&lang=js"

import "./LineDetail.vue?vue&type=style&index=0&id=4916d420&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./LineDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4916d420"]])

export default __exports__